import conditions from './conditions.svg';
import languages from './languages.svg';
import map from './map.svg';
import plans from './plans.svg';
import autojumpWebp from './autojump.webp';
import highlightWebp from './highlight.webp';
import topWebp from './top.webp';

export default {
  conditions,
  languages,
  map,
  plans,
  autojump: {
    fallback: '/icons/realtorLanding/autojump.gif',
    webp: autojumpWebp
  },
  highlight: {
    fallback: '/icons/realtorLanding/highlight.gif',
    webp: highlightWebp
  },
  top: {
    fallback: '/icons/realtorLanding/top.gif',
    webp: topWebp
  }
};
